export enum UILayout {
  Grid = 'grid',
  Table = 'table'
}
